import { render, staticRenderFns } from "./DIAS.vue?vue&type=template&id=5ede0e32&scoped=true&"
import script from "./DIAS.vue?vue&type=script&lang=js&"
export * from "./DIAS.vue?vue&type=script&lang=js&"
import style0 from "./DIAS.vue?vue&type=style&index=0&id=5ede0e32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede0e32",
  null
  
)

export default component.exports